import React, {useEffect, useState} from 'react'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import PropTypes from 'prop-types';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import isEmail from 'validator/lib/isEmail';
import InputAdornment from "@material-ui/core/InputAdornment";
import {MenuItem} from "@material-ui/core";

const initialUser = {
    name: '',
    email: '',
    contact_number: '',
    street: '',
    suburb: '',
    city: '',
    postal_address_suburb: '',
    postal_address_street: '',
    postal_address_city: '',
}


const AddUserDialog = props => {
    const [user, setUser] = useState(initialUser)
    const {addUserHandler} = props
    const [open, setOpen] = React.useState(false)
    const [error, setError] = useState(false);
    //input error message
    const [nameError, setNameError] = useState(false);
    const [nameErrorMsg, setNameErrorMsg] = useState('');
    const [emailError, setEmailError] = useState(false);
    const [emailErrorMsg, setEmailErrorMsg] = useState('');
    const [contactError, setContactError] = useState(false);
    const [contactErrorMsg, setContactErrorMsg] = useState('');
    const [streetError, setStreetError] = useState(false);
    const [streetErrorMsg, setStreetErrorMsg] = useState('');
    const [suburbError, setSuburbError] = useState(false);
    const [suburbErrorMsg, setSuburbErrorMsg] = useState('');
    const [cityError, setCityError] = useState(false);
    const [cityErrorMsg, setCityErrorMsg] = useState('');
    const [postalSuburbError, setPostalSuburbError] = useState(false);
    const [postalSuburbErrorMsg, setPostalSuburbErrorMsg] = useState('');
    const [postalStreetError, setPostalStreetError] = useState(false);
    const [postalStreetErrorMsg, setPostalStreetErrorMsg] = useState('');
    const [postalCityError, setPostalCityError] = useState(false);
    const [postalCityErrorMsg, setPostalCityErrorMsg] = useState('');
    const [addButton, setAddButton] = useState(false)
    const [autoError, setAutoError] = useState(false);


    const [switchState, setSwitchState] = React.useState({
        addMultiple: false,
    })

    const handleSwitchChange = name => event => {
        setSwitchState({...switchState, [name]: event.target.checked})
    }

    const resetSwitch = () => {
        setSwitchState({ addMultiple: false })
    }

    const handleClickOpen = () => {
        setOpen(true)
    }

    const handleClose = () => {
        setOpen(false)
        resetSwitch()
    }

    const handleAdd = event => {

        //if any field is empty don't submit
        if (user.name === '') {
            setNameError(true)
            setNameErrorMsg('Field is required')
            setError(true);
            return;
        }
        if (user.email === '') {
            setEmailError(true)
            setEmailErrorMsg('Field is required')
            setError(true);
            return;
        }
        if (!isEmail(user.email)) {
            setEmailError(true)
            setEmailErrorMsg('Email not valid')
            setError(true);
            return;
        }
        if (user.contact_number === '') {
            setContactError(true)
            setContactErrorMsg('Field is required')
            setError(true);
            return;
        }
        if (user.street === '') {
            setStreetError(true)
            setStreetErrorMsg('Field is required')
            setError(true);
            return;
        }
        if (user.suburb === '') {
            setSuburbError(true)
            setSuburbErrorMsg('Field is required')
            setError(true);
            return;
        }
        if (user.city === '') {
            setCityError(true)
            setCityErrorMsg('Field is required')
            setError(true);
            return;
        }
        if (user.postal_address_street === '') {
            setPostalStreetError(true)
            setPostalStreetErrorMsg('Field is required')
            setError(true);
            return;
        }
        if (user.postal_address_suburb === '') {
            setPostalSuburbError(true)
            setPostalSuburbErrorMsg('Field is required')
            setError(true);
            return;
        }
        if (user.postal_address_city === '') {
            setPostalCityError(true)
            setPostalCityErrorMsg('Field is required')
            setError(true);
            return;
        }
        //reset error messages
        setError(false)
        setEmailError(false);
        setNameError(false);
        setCityError(false);
        setContactError(false);
        setStreetError(false);
        setSuburbError(false);
        setPostalSuburbError(false);
        setPostalStreetError(false);
        setPostalCityError(false);

        addUserHandler(user)
        setUser(initialUser)
        switchState.addMultiple ? setOpen(true) : setOpen(false)
    }

    const handleChange = name => ({ target: { value } }) => {
        //validate onchange
        if (name === 'name' && value === '') {
            setNameError(true)
            setNameErrorMsg('Field is required')
        } else {
            setNameError(false);
            setNameErrorMsg('')
        }
        if (name === 'email' && value === '') {
            setEmailError(true)
            setEmailErrorMsg('Field is required')
        } else {
            setEmailError(false)
            setEmailErrorMsg('')
        }
        if (name === 'email' && isEmail(value) === false) {
            console.log(emailError)
            setEmailError(true)
            setEmailErrorMsg('Email not valid')
        } else {
            setEmailError(false)
            setEmailErrorMsg('')
        }
        if (name === 'contact_number' && value === '') {
            setContactError(true)
            setContactErrorMsg('Field is required')
        } else {
            setContactError(false)
            setContactErrorMsg('')
        }
        if (name === 'contact_number' && value.length < 9) {
            console.log(value.length < 9);
            setContactError(true)
            setContactErrorMsg('Mobile number must be a 9 digit number')
        } else {
            setContactError(false)
            setContactErrorMsg('')
        }
        if (name === 'city' && value === '') {
            setCityError(true)
            setCityErrorMsg('Field is required')
        } else {
            setCityError(false)
            setCityErrorMsg('')
        }
        if (name === 'street' && value === '') {
            setStreetError(true)
            setStreetErrorMsg('Field is required')
        } else {
            setStreetError(false)
            setStreetErrorMsg('')
        }
        if (name === 'suburb' && value === '') {
            setSuburbError(true)
            setSuburbErrorMsg('Field is required')
        } else {
            setSuburbError(false)
            setSuburbErrorMsg('')
        }
        if (name === 'postal_address_suburb' && value === '') {
            setPostalSuburbError(true)
            setPostalSuburbErrorMsg('Field is required')
        } else {
            setPostalSuburbError(false)
            setPostalSuburbErrorMsg('')
        }
        if (name === 'postal_address_street' && value === '') {
            setPostalStreetError(true)
            setPostalStreetErrorMsg('Field is required')
        } else {
            setPostalStreetError(false)
            setPostalStreetErrorMsg('')
        }
        if (name === 'postal_address_city' && value === '') {
            setPostalCityError(true)
            setPostalCityErrorMsg('Field is required')
        } else {
            setPostalCityError(false)
            setPostalCityErrorMsg('')
        }

        //update user object
        setUser({...user, [name]: value})
    }

    useEffect(() => {
        let role_based_perm = JSON.parse(localStorage.getItem('role_based_permissions'));
        let direct_perm = JSON.parse(localStorage.getItem('direct_permissions'));
        console.log("role_based: ", role_based_perm);
        console.log("direct perm: ", direct_perm);
        if (role_based_perm === null || role_based_perm === undefined) {
            setAddButton(false);
        } else {
            role_based_perm.map((perm, i) => {
                if (perm.name === 'add aggregators') {
                    setAddButton(true);
                }
            })
        }
        if (direct_perm === null || direct_perm === undefined) {
            setAddButton(false);
        } else {
            direct_perm.map((perm, i) => {
                if (perm.name === 'add aggregators') {
                    setAddButton(true);
                }
            })
        }
    }, [])

    const autoPopulate = () => {
        if (user.city === '' || user.suburb === '' || user.street === '') {
            setAutoError(true)
            //update user object
            setUser({...user, postal_address_city: '', postal_address_street: '', postal_address_suburb: ''})
        } else {
            setAutoError(false)
            setUser({
                ...user,
                postal_address_city: user.city,
                postal_address_street: user.street,
                postal_address_suburb: user.suburb
            })
        }
    }

    return (
        <div>
            {addButton && (
                <Tooltip title="Add New">
                 <span className="btn btn-sm btn-primary mr-5" onClick={handleClickOpen}>
                    <i className="fa fa-plus-square"/> &nbsp;&nbsp;Add Aggregator
                </span>
                </Tooltip>
            )}

            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title">Add Aggregator</DialogTitle>
                <DialogContent>
                    <DialogContentText>Please fill in details</DialogContentText>
                    {error && (
                        <small className="text-danger">Make sure every field is filled in.</small>
                    )}
                    <TextField
                        error={nameError}
                        helperText={nameErrorMsg}
                        required
                        autoFocus
                        margin="dense"
                        label="Name"
                        type="text"
                        fullWidth
                        inputProps={{style: {textTransform: 'capitalize'}}}
                        value={user.name}
                        onChange={handleChange('name')}
                    />
                    <TextField
                        error={emailError}
                        helperText={emailErrorMsg}
                        required
                        margin="dense"
                        label="Email"
                        type="email"
                        fullWidth
                        inputProps={{style: {textTransform: 'lowercase'}}}
                        value={user.email}
                        onChange={handleChange('email')}
                    />
                    <TextField
                        error={contactError}
                        helperText={contactErrorMsg}
                        required
                        margin="dense"
                        label="Contact Number"
                        type="number"
                        fullWidth
                        value={user.contact_number}
                        onChange={handleChange('contact_number')}
                        onInput={(e) => {
                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 9)
                        }}
                        InputProps={{
                            startAdornment: <InputAdornment position="start">
                                +263
                            </InputAdornment>
                        }}
                    />
                    <TextField
                        error={streetError}
                        helperText={streetErrorMsg}
                        required
                        margin="dense"
                        label="Street"
                        type="text"
                        fullWidth
                        value={user.street}
                        onChange={handleChange('street')}
                    />
                    <TextField
                        error={suburbError}
                        helperText={suburbErrorMsg}
                        required
                        margin="dense"
                        label="Suburb"
                        type="text"
                        fullWidth
                        value={user.suburb}
                        onChange={handleChange('suburb')}
                    />
                    <TextField
                        error={cityError}
                        helperText={cityErrorMsg}
                        onChange={handleChange('city')}
                        name="city"
                        label="City"
                        select
                        fullWidth
                        required>
                        {user.city !== '' && (
                            <MenuItem selected={true} value={user.city}>
                                {user.city}
                            </MenuItem>
                        )}
                        <MenuItem value disabled={true}>Select City</MenuItem>
                        <MenuItem value="Arcturus">Arcturus</MenuItem>
                        <MenuItem value="Banket">Banket</MenuItem>
                        <MenuItem value="Beitbridge">Beitbridge</MenuItem>
                        <MenuItem value="Bindura">Bindura</MenuItem>
                        <MenuItem value="Buhera">Buhera</MenuItem>
                        <MenuItem value="Bulawayo">Bulawayo</MenuItem>
                        <MenuItem value="Chegutu">Chegutu</MenuItem>
                        <MenuItem value="Chimanimani">Chimanimani</MenuItem>
                        <MenuItem value="Chinhoyi">Chinhoyi</MenuItem>
                        <MenuItem value="Chipinge">Chipinge</MenuItem>
                        <MenuItem value="Chiredzi">Chiredzi</MenuItem>
                        <MenuItem value="Chitungwiza">Chitungwiza</MenuItem>
                        <MenuItem value="Chivhu">Chivhu</MenuItem>
                        <MenuItem value="Darwendale">Darwendale</MenuItem>
                        <MenuItem value="Goromonzi">Goromonzi</MenuItem>
                        <MenuItem value="Guruve">Guruve</MenuItem>
                        <MenuItem value="Gwanda">Gwanda</MenuItem>
                        <MenuItem value="Gweru">Gweru</MenuItem>
                        <MenuItem value="Harare">Harare</MenuItem>
                        <MenuItem value="Hwange">Hwange</MenuItem>
                        <MenuItem value="Kadoma">Kadoma</MenuItem>
                        <MenuItem value="Kariba">Kariba</MenuItem>
                        <MenuItem value="Karoi">Karoi</MenuItem>
                        <MenuItem value="Kezi">Kezi</MenuItem>
                        <MenuItem value="Kwekwe">Kwekwe</MenuItem>
                        <MenuItem value="Lupane">Lupane</MenuItem>
                        <MenuItem value="Marondera">Marondera</MenuItem>
                        <MenuItem value="Masvingo">Masvingo</MenuItem>
                        <MenuItem value="Mazoe">Mazoe</MenuItem>
                        <MenuItem value="Mhangura">Mhangura</MenuItem>
                        <MenuItem value="Mount Darwin">Mount Darwin</MenuItem>
                        <MenuItem value="Mukumbura">Mukumbura</MenuItem>
                        <MenuItem value="Murehwa">Murehwa</MenuItem>
                        <MenuItem value="Mutare">Mutare</MenuItem>
                        <MenuItem value="Mutoko">Mutoko</MenuItem>
                        <MenuItem value="Mvurwi">Mvurwi</MenuItem>
                        <MenuItem value="Norton">Norton</MenuItem>
                        <MenuItem value="Nyanga">Nyanga</MenuItem>
                        <MenuItem value="Plumtree">Plumtree</MenuItem>
                        <MenuItem value="Redcliff">Redcliff</MenuItem>
                        <MenuItem value="Rusape">Rusape</MenuItem>
                        <MenuItem value="Ruwa">Ruwa</MenuItem>
                        <MenuItem value="Sakubva">Sakubva</MenuItem>
                        <MenuItem value="Shamva">Shamva</MenuItem>
                        <MenuItem value="Shurugwi">Shurugwi</MenuItem>
                        <MenuItem value="Victoria Falls">Victoria Falls</MenuItem>
                        <MenuItem value="Zvishavane">Zvishavane</MenuItem>
                    </TextField>
                    <button className="btn btn-sm btn-primary" onClick={autoPopulate}>Same as Above</button>
                    {autoError && (
                        <label><span className="text-danger">Please fill in street, suburb & city above</span></label>
                    )}
                    <TextField
                        error={postalStreetError}
                        helperText={postalStreetErrorMsg}
                        required
                        margin="dense"
                        label="postal address street"
                        type="text"
                        fullWidth
                        value={user.postal_address_street}
                        onChange={handleChange('postal_address_street')}
                    />
                    <TextField
                        error={postalSuburbError}
                        helperText={postalSuburbErrorMsg}
                        required
                        margin="dense"
                        label="postal address suburb"
                        type="text"
                        fullWidth
                        value={user.postal_address_suburb}
                        onChange={handleChange('postal_address_suburb')}
                    />


                    <TextField
                        error={postalCityError}
                        helperText={postalCityErrorMsg}
                        onChange={handleChange('postal_address_city')}
                        name="postal_address_city"
                        label="Postal Address City"
                        select
                        fullWidth
                        required>
                        {user.postal_address_city !== '' && (
                            <MenuItem selected={true} value={user.postal_address_city}>
                                {user.postal_address_city}
                            </MenuItem>
                        )}
                        <MenuItem value disabled={true}>Select City</MenuItem>
                        <MenuItem value="Arcturus">Arcturus</MenuItem>
                        <MenuItem value="Banket">Banket</MenuItem>
                        <MenuItem value="Beitbridge">Beitbridge</MenuItem>
                        <MenuItem value="Bindura">Bindura</MenuItem>
                        <MenuItem value="Buhera">Buhera</MenuItem>
                        <MenuItem value="Bulawayo">Bulawayo</MenuItem>
                        <MenuItem value="Chegutu">Chegutu</MenuItem>
                        <MenuItem value="Chimanimani">Chimanimani</MenuItem>
                        <MenuItem value="Chinhoyi">Chinhoyi</MenuItem>
                        <MenuItem value="Chipinge">Chipinge</MenuItem>
                        <MenuItem value="Chiredzi">Chiredzi</MenuItem>
                        <MenuItem value="Chitungwiza">Chitungwiza</MenuItem>
                        <MenuItem value="Chivhu">Chivhu</MenuItem>
                        <MenuItem value="Darwendale">Darwendale</MenuItem>
                        <MenuItem value="Goromonzi">Goromonzi</MenuItem>
                        <MenuItem value="Guruve">Guruve</MenuItem>
                        <MenuItem value="Gwanda">Gwanda</MenuItem>
                        <MenuItem value="Gweru">Gweru</MenuItem>
                        <MenuItem value="Harare">Harare</MenuItem>
                        <MenuItem value="Hwange">Hwange</MenuItem>
                        <MenuItem value="Kadoma">Kadoma</MenuItem>
                        <MenuItem value="Kariba">Kariba</MenuItem>
                        <MenuItem value="Karoi">Karoi</MenuItem>
                        <MenuItem value="Kezi">Kezi</MenuItem>
                        <MenuItem value="Kwekwe">Kwekwe</MenuItem>
                        <MenuItem value="Lupane">Lupane</MenuItem>
                        <MenuItem value="Marondera">Marondera</MenuItem>
                        <MenuItem value="Masvingo">Masvingo</MenuItem>
                        <MenuItem value="Mazoe">Mazoe</MenuItem>
                        <MenuItem value="Mhangura">Mhangura</MenuItem>
                        <MenuItem value="Mount Darwin">Mount Darwin</MenuItem>
                        <MenuItem value="Mukumbura">Mukumbura</MenuItem>
                        <MenuItem value="Murehwa">Murehwa</MenuItem>
                        <MenuItem value="Mutare">Mutare</MenuItem>
                        <MenuItem value="Mutoko">Mutoko</MenuItem>
                        <MenuItem value="Mvurwi">Mvurwi</MenuItem>
                        <MenuItem value="Norton">Norton</MenuItem>
                        <MenuItem value="Nyanga">Nyanga</MenuItem>
                        <MenuItem value="Plumtree">Plumtree</MenuItem>
                        <MenuItem value="Redcliff">Redcliff</MenuItem>
                        <MenuItem value="Rusape">Rusape</MenuItem>
                        <MenuItem value="Ruwa">Ruwa</MenuItem>
                        <MenuItem value="Sakubva">Sakubva</MenuItem>
                        <MenuItem value="Shamva">Shamva</MenuItem>
                        <MenuItem value="Shurugwi">Shurugwi</MenuItem>
                        <MenuItem value="Victoria Falls">Victoria Falls</MenuItem>
                        <MenuItem value="Zvishavane">Zvishavane</MenuItem>
                    </TextField>
                </DialogContent>
                <DialogActions>
                    <Tooltip title="Add multiple">
                        <Switch
                            checked={switchState.addMultiple}
                            onChange={handleSwitchChange('addMultiple')}
                            value="addMultiple"
                            inputProps={{ 'aria-label': 'secondary checkbox' }}
                        />
                    </Tooltip>
                    <Button onClick={handleClose} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleAdd} color="primary">
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

AddUserDialog.propTypes = {
    addUserHandler: PropTypes.func.isRequired,
}

export default AddUserDialog;
